import React from 'react';
import {Checkbox, DateTimePicker, FileInput, TextInput, TextInputWithTooltip} from "../BasicFormFields/index";
import BasicLabel from "../BasicFormFields/BasicLabel";

const components = {
    'text': TextInput,
    'text-with-tooltip': TextInputWithTooltip,
    'hidden': () => "",
    'checkbox': Checkbox,
    'file': FileInput,
    'date': DateTimePicker,
    'label': BasicLabel
};

export default components;



// WEBPACK FOOTER //
// ./public/components/forms/Component Sets/UnvalidatedBasicFormComponents.jsx